<script lang="ts">
  import {  Col, Container, Row } from "sveltestrap";
  import LoginSimpleForm from "./LoginSimpleForm.svelte";
</script>
<section>         
    <Container fluid class="p-0">
      <Row>
        <Col xs="12">
          <div class="login-card">
            <LoginSimpleForm />
          </div>
        </Col>
      </Row>
    </Container>
</section>
